import { clone, setWith } from "lodash-es";

export const setIn = (state, name, value) => {
  return setWith(clone(state), name, value, clone);
}